import { _on } from '../../utils';

_on('click', 'js--seo-collapse-expand', e => {
  const target = (e.target as HTMLElement).dataset.target;
  document.querySelector(`.seo-collapse[data-target=${target}]`).classList.add('expanded');
  (e.target as HTMLElement).remove();
});
